import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./_saldo.scss";

function SaldoGas() {
  const navigate = useNavigate();
  const saldo = useSelector((user) => user.gas?.saldo);
  const saldoDecimal = saldo && saldo.toString().split(".");

  let saldoArray = new Array();
  saldoArray = saldoDecimal;
  return (
    <div className="saldo">
      <div className="saldo-left">
        <span className="label">
          Il tuo saldo è{" "}
          {saldo && saldo >= 0 ? "a credito di:" : "a debito di:"}
        </span>
        <p className="main">
          {saldo && saldo !== 0 ? saldoArray[0] : "0"},{" "}
          <span>{saldo && saldoArray[1] !== undefined ? saldoArray[1].substring(0,2) : '00' } €</span>
        </p>
      </div>
      <div className="saldo-right">
        <p className="label">
            Ricarica
        </p>
        <div
          className="buttonRicarica"
          onClick={() => navigate("/enrica/ricarica")}
        >
          <span>+</span>
        </div>
      </div>
    </div>
  );
}

export default SaldoGas;
